import { render } from "./addProduct.vue?vue&type=template&id=1ba93417&scoped=true"
import script from "./addProduct.vue?vue&type=script&lang=js"
export * from "./addProduct.vue?vue&type=script&lang=js"

import "./addProduct.vue?vue&type=style&index=0&id=1ba93417&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba93417"]])

export default __exports__